// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"73":"atk-vue-query-builder","225":"vendor-vue-flatpickr","338":"atk-vue-multiline","534":"vendor-vue","567":"atk-vue-tree-item-selector","657":"atk-vue-item-search","875":"atk-vue-inline-edit"}[chunkId] + ".min.js";
};